<template>
  <wc-dialog
    :showDialog='showDialog'
    title="Add Line"
    hideSave
    @cancel="$emit('cancel')"
    width='550'
    :fullscreen='$vuetify.breakpoint.smAndDown'
  >
    <template v-slot:dialog-actions>
      <v-btn text color='error' @click='resetChoices'>
        <v-icon left>
          mdi-refresh
        </v-icon>
        Reset
      </v-btn>
    </template>
      <v-stepper v-model='position' vertical>
         <!-- step 1 -->
        <v-stepper-step :complete='position > 1' step='1'>
          Division
          <small>{{ divisionChosen }}</small>
        </v-stepper-step>
        <v-stepper-content step='1' class='text-xs-left'>
          <stepper-button v-for='d in divisions' :key='d.id' :text='d.division' @click.native='chooseDivision(d)'></stepper-button>
        </v-stepper-content>
        <!-- end step 1 -->

        <!-- step 2 -->
        <v-stepper-step :complete='position > 2' step='2'>
          Category
          <small>{{ categoryChosen }}</small>
        </v-stepper-step>
        <v-stepper-content step='2' class='text-xs-left'>
          <stepper-button v-for='c in filteredCategories' :key='c.id' :text='c.description' @click.native='chooseCategory(c)'></stepper-button>
        </v-stepper-content>
        <!-- end step 2 -->

        <!-- step 3 -->
        <v-stepper-step :complete='position > 3' step='3'>
          Project
          <small>{{ projectChosen }}</small>
        </v-stepper-step>
        <v-stepper-content step='3' class='text-xs-center text-sm-left'>
          <wc-loading v-if='projectLoader' msg=' Gathering projects...'></wc-loading>
          <v-autocomplete
            v-else
            :items='filteredProjects'
            no-data-text='No Projects Found'
            item-text='name'
            return-object
            v-model='workedOnCopy.project'
            hint='start typing to filter the list'
            @input='chooseProject()'
          ></v-autocomplete>
        </v-stepper-content>
        <!-- end step 4 -->

        <!-- step 4 -->
        <v-stepper-step :complete='position > 4' step='4'>
          Detail
          <small>{{ detailChosen }}</small>
        </v-stepper-step>
        <v-stepper-content step='4' class='text-xs-center text-sm-left'>
          <wc-loading v-if='detailLoader' msg=' Gathering details...'></wc-loading>
          <stepper-button v-else v-for='d in projectDetails' :key='d.id' :text='d.detail_display' @click.native='chooseDetail(d)'></stepper-button>
        </v-stepper-content>
        <!-- end step 4 -->

        <!-- step 5 -->
        <v-stepper-step :complete='position > 5' step='5'>
          Hours
          <small>{{ workedOn.num_hours }}</small>
        </v-stepper-step>
        <v-stepper-content step='5' class='text-xs-center text-sm-left'>
          <v-select :items='availHours' label='For how long?' v-model='workedOnCopy.num_hours' @input='setHours()'></v-select>
        </v-stepper-content>
        <!-- end step 5 -->

        <!-- step 6 -->
        <v-stepper-step :complete='position > 6' step='6'>
          Finishing Up
        </v-stepper-step>
        <v-stepper-content step='6' class='text-xs-center text-sm-left'>
          <v-text-field v-model='workedOnCopy.notes' label='Any notes?'></v-text-field>
          <v-btn color='info' block @click="$emit('save', workedOnCopy)">Save</v-btn>
        </v-stepper-content>
        <!-- end step 6 -->
        <br>
        <div class='text-xs-center'>
        </div>
      </v-stepper>
   
  </wc-dialog>
</template>

<script>
import projectsAPI from '@/modules/projects/api/projects'
import timesheetsAPI from '../api/timesheets'
import StepperButton from './StepperButton'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
// import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'entry-detail-dialog',
  mixins: [formRules],
  props: {
    entry: {
      required: true
    },
    workedOn: {
      required: true
    },
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    position: 1,
    projectLoader: false,
    detailLoader: false,
    categoriesLoader: false,
    project: null,
    division: null,
    categories: [],
    projects: [],
    projectDetails: [],
    workedOnCopy: {},

  }),
  mounted () {
    this.resetChoices()
  },
  computed: {
    divisions () {
      return _.orderBy(this.$store.state.misc.divisions, 'order')
    },
    divisionChosen () {
      if (this.division) {
        return this.division.division
      }
      return 'Choose a division'
    },
    categoryChosen () {
      if (this.workedOnCopy.category) {
        let category = _.find(this.categories, ['id', this.workedOnCopy.category])
        return category.description
      }
      return ''
    },
    projectChosen () {
      if (this.project) {
        return this.project.description
      }
      return ''
    },
    detailChosen () {
      if (this.workedOn.detail) {
        let tmp = _.find(this.details, function (d) { return d.detail === this.workedOn.detail })
        return tmp.detail_desc
      }
      return ''
    },
    filteredProjects () {  // do we get this to just find projects that have details attached?
      if (this.projects) {
        return _.orderBy(this.projects, ['name'])
      }
      return null
    },
    filteredCategories () {
      if (this.categories.length) {
        // move 'Specific Project' to always be the last item
        let cat = _.cloneDeep(this.categories)
        let sp = _.find(cat, ['project_required', true])
        console.log(sp)
        cat = miscServices.removeObject(cat, sp)
        cat.push(sp)
        return cat
      }
      return []
    },
    availHours () {
      return _.reverse(miscServices.buildHours(0.25, this.entry.hours_left_to_assign, 0.25, 'hrs'))
    }
  },
  watch: {
    'showDialog' () {
      if (this.showDialog) {
        this.resetChoices()
      }
    }
  },
  methods: {
    calcHoursWorked () {
      this.entryCopy.hours_worked = this.hourWorked
    },
    async chooseDivision (d) {
      this.division = d
      this.position = 2
      this.categoriesLoader = true
      this.categories = await timesheetsAPI.getTimesheetCategories(d.id)
      this.categoriesLoader = false
    },
    async chooseCategory (c) {
      this.workedOnCopy.category = c.id
      if (c.description === 'Specific Project') {
        this.position = 3
        this.projectLoader = true
        this.projects = await projectsAPI.getDivisionProjects(this.division)
        this.projectLoader = false
      } else {
        this.position = 5
      }
    },
    async chooseProject () {
      console.log(this.workedOnCopy.project)
      this.project = _.cloneDeep(this.workedOnCopy.project)
      console.log(this.workedOnCopy.project.detail_required)
      if (this.workedOnCopy.project.detail_required) {
        console.log('pos 4')
        this.position = 4
        this.detailLoader = true
        this.projectDetails = await projectsAPI.getProjectTimesheetDetails(this.workedOnCopy.project.id)
        this.detailLoader = false
      } else {
        this.position = 5
      }
      this.workedOnCopy.project = this.workedOnCopy.project.id
    },
    chooseDetail (d) {
      this.workedOnCopy.detail = d.detail
      this.position = 5
    },
    setHours () {
      if (this.workedOnCopy.num_hours > 0) {
        this.position = 6
      }
    },
    resetChoices () {
      this.workedOnCopy.entry = this.entry.id
      this.workedOnCopy.category = null
      this.workedOnCopy.project = null
      this.workedOnCopy.detail = null
      this.workedOnCopy.num_hours = ''
      this.workedOnCopy.notes = ''
      this.position = 1
      this.division = null
      this.project = null
    },
    cancel () {
      this.resetChoices()
      this.$emit('cancel')
    },
  },
  components: {
    'stepper-button': StepperButton,
  }
}
</script>